define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');
    const CC = require('CC');

    /**
     * Renders the cell value an pill with provided mapping
     * @param {Object} options
     * @returns column definition
     */
    const EnumCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    /**
                     * map the raw value to display value
                     */
                    rawToDisplayMap: {},
                    type: 'string',
                    chooseStyle: function(data, row) {
                        return this.isActive(data) ? 'data-grid__pill--active' : 'data-grid__pill--inactive';
                    },
                    className: 'dt-body-left text-left',
                    isActive: data => {
                        // By default, just return the data value directly
                        return data;
                    },
                    defaultContent: '',
                    onDisplay: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        const value = this.rawToDisplayMap[String(translatedValue)];
                        const index = _.keys(this.rawToDisplayMap).indexOf(String(translatedValue));
                        if (CC.utils.hasValue(value)) {
                            return _.template(
                                /*template*/
                                `<span class="data-grid__pill <%- type %>" data-enum-index="<%- index %>"><%- value %></span>`
                            )({
                                value: value,
                                type: this.chooseStyle(data, row),
                                index: index
                            });
                        } else {
                            return '';
                        }
                    },
                    onExport: function(data, type, row, meta, translatedValue) {
                        return this.rawToDisplayMap[String(data)];
                    }
                },
                options
            )
        };
    };
    return EnumCell;
});
